module.exports = __webpack_public_path__ + "img/processo isolamento 1.474ccabb.webp";